import {InjectionKey, Ref} from "vue";
import {EditableOrderRule} from "./editable-order-adjustment";
import {DecimalInputValue} from "@hantera/design-system";

export interface NewRowAdjustment {
  rowId: string
  name?: string
  value: DecimalInputValue
}

export const newRowAdjustmentKey: InjectionKey<Ref<NewRowAdjustment | undefined>> = Symbol('rowNewAdjustmentKey');

export const orderRulesKey: InjectionKey<Ref<EditableOrderRule[]>> = Symbol('orderRulesKey');